import React from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, CheckboxUI } from '../Interface';

export const VatCodeFields = ({ viewField }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="md:col-span-2 col-span-4">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          name="active"
          type="checkbox"
          component={CheckboxUI}
          onChange={(e) => {
            const value = e.target.checked;
            setFieldValue('active', value).then(() => {
              validateField('active');
            });
          }}
          checked={values.active ?? false}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          name="worksheet"
          type="checkbox"
          component={CheckboxUI}
          onChange={(e) => {
            const value = e.target.checked;
            setFieldValue('worksheet', value).then(() => {
              validateField('worksheet');
            });
          }}
          checked={values.worksheet ?? false}
          fullWidth
          label={<FormLabelUI text="Munkalap" />}
          disabled={viewField}
        />
      </div>
    </div>
  );
};

export default VatCodeFields;
